import { useCurrentSafe } from 'store';
import { PermissionType } from 'types';

import useAddress from './use-address';

export const usePermissionWarning = (permission: PermissionType) => {
  const address = useAddress();

  const { currentSafe } = useCurrentSafe();
  const owner = currentSafe?.permissions?.find((owner) => owner.address === address);

  if (!owner?.permissions.includes(permission)) {
    return permission === 'PROPOSE'
      ? 'Your current permissions don’t allow you to create Txn'
      : permission === 'VOTE'
        ? 'Your current permissions don’t allow you to sign Txn'
        : 'Your current permissions don’t allow you to execute Txn';
  }

  return null;
};
